import React, { useEffect, useRef } from "react";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import { Toast } from "primereact/toast";
import localeText from "../../../../locale";

import MultiPaymentSelection from "../MultiPaymentSelection/MultiPaymentSelection";
import SinglePaymentSelection from "../SinglePaymentSelection/SinglePaymentSelection";
import useCheckout from "./hooks/useCheckout";
import "./Checkout.css";
import { usePayment } from "./context/PaymentContext";
import UnifiedOrderSummary from "../UnifiedOrderSummary/UnifiedOrderSummary";

const CheckoutContent = ({
  cashback,
  order,
  orderItems,
  setOrder,
  currencyProduct,
  currencyCodeUser,
  currencyUser,
  setAmountTransfer,
  currencyExchangeValue,
  setPrice,
  amountWallet,
  walletBalance,
  walletBalanceForex,
  price,
  amountBankTransfer,
  setAmountBankTransfer,
  bankTransferReceipt,
  setBankTransferReceipt,
  amountToPayWithExtracredit,
  setAmountToPayWithExtracredit,
  currencyCode,
  setAmountWallet,
  walletExtracoinBalance,
  userInfo,
  userPercentExtracoin,
  setAddressInfo,
  setPriceForex,
  setDisplayPaymentModal,
  sendMethod,
  setSendMethod,
  walletExtracoinBalanceForex,
  setAmountShipmentForexProduct,
  amountShipmentForexProduct,
  setLoading,
  page,
  setPage,
  showErrorToast,
}) => {
  const {
    combinePayment,
    setCombinePayment,
    calculateRemainingPrice,
    canProceed,
    setSendMethod: setPaymentSendMethod,
  } = usePayment();

  const toast = useRef(null);

  const {
    loading,
    amountShipmentForexUser,
    shippingQuotes,
    showMessageSellerResponsibility,
    country,
    state,
    city,
    district,
    address,
    number,
    postalCode,
    validateCheckout: validateShippingCheckout,
    isPickup,
  } = useCheckout({
    setAddressInfo,
    setPriceForex,
    setDisplayPaymentModal,
    setAmountShipmentForexProduct,
    setAmountTransfer,
  });

  const currencyFormat = {
    USD: "$",
    EUR: "€",
    BRL: "R$",
    GBP: "£",
    JPY: "¥",
    CNY: "¥",
    AUD: "AU$",
    CAD: "CA$",
    CHF: "CHF",
  };

  const isFringeBenefitsPage = window.location?.pathname?.toLowerCase()?.includes("fringe");
  const orderTotal = isFringeBenefitsPage
    ? order?.totalOrder
    : (order?.amountOrder || 0) + (order?.amountShipment || 0) + (order?.amountToPlatform || 0);
  const remainingPrice = calculateRemainingPrice();

  const isServiceOrDownloadable = () => {
    return order?.itens?.some((item) => item?.product?.service || item?.product?.downloadable);
  };

  const hasCompleteAddress = () => {
    return !!(address && city && country && district && number && postalCode && state);
  };

  const validatePaymentCheckout = async (finishOrder = false) => {
    if (finishOrder) {
      await validateShippingCheckout(true);
    } else {
      await validateShippingCheckout(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Sincronizar sendMethod externo com PaymentContext
  useEffect(() => {
    if (sendMethod) {
      setPaymentSendMethod(sendMethod);
    }
  }, [sendMethod, setPaymentSendMethod]);

  return (
    <div className="pt-4 pb-8">
      <Toast ref={toast} />

      <div
        className="font-bold text-xl my-3 flex gap-2 align-items-center justify-content-between"
        style={{ color: "#344563" }}
      >
        {localeText("paymentCheckout")}{" "}
        <Button
          link
          className="p-no-outline flex gap-2 align-items-center"
          style={{ color: "#245AE5" }}
          onClick={() => setPage(page - 1)}
        >
          <i className="pi pi-arrow-left text-xs"></i>{" "}
          <span className="underline">{localeText("backAction")}</span>
        </Button>
      </div>

      <div className="grid grid-nogutter gap-4">
        <div className="col-12 md:col-8">
          <div className="flex mb-4 gap-3 sm:gap-3 gap-2 items-center">
            <div className="sm:mr-0 mr-2" style={{ minWidth: 36, minHeight: 24 }}>
              <InputSwitch
                checked={combinePayment}
                onChange={(e) => setCombinePayment(e.value)}
                className="sm:scale-100 scale-90"
                style={{ minWidth: 36, minHeight: 24 }}
              />
            </div>
            <div>
              <div className="text-sm font-medium mb-1">{localeText("combinePaymentMethods")}</div>
              <div className="text-xs" style={{ color: "#68686E" }}>
                {localeText("combinePaymentExplanation")}
              </div>
            </div>
          </div>

          <div
            className="card p-4 border-round-lg border-none"
            style={{ boxShadow: "0px 0px 40px #5F58521A" }}
          >
            <div className="font-bold mb-2" style={{ color: "#344563" }}>
              {localeText("selectPaymentMethod")}
            </div>
            <div className="text-sm mb-3" style={{ color: "#344563" }}>
              {localeText("paymentTermsAcceptance")}
            </div>

            {combinePayment ? (
              <MultiPaymentSelection toast={toast} totalPrice={orderTotal} combinePayment={combinePayment} />
            ) : (
              <SinglePaymentSelection
                currencyProduct={currencyProduct}
                currencyFormat={currencyFormat}
                toast={toast}
                combinePayment={combinePayment}
                totalPrice={orderTotal}
              />
            )}
          </div>
        </div>

        <UnifiedOrderSummary
          context="payment"
          order={order}
          isFringeBenefitsPage={isFringeBenefitsPage}
          currencyProduct={currencyProduct}
          currencyCodeUser={currencyCodeUser}
          sendMethod={sendMethod}
          shippingQuotes={shippingQuotes}
          showMessageSellerResponsibility={showMessageSellerResponsibility}
          amountShipmentForexUser={amountShipmentForexUser}
          currencyUser={currencyUser}
          currencyFormat={currencyFormat}
          walletExtracoinBalance={walletExtracoinBalance}
          currencyExchangeValue={currencyExchangeValue}
          orderTotal={orderTotal}
          userPercentExtracoin={userPercentExtracoin}
          walletExtracoinBalanceForex={walletExtracoinBalanceForex}
          orderCurrency={currencyProduct}
          walletBalance={walletBalance}
          amountToPayWithExtracredit={amountToPayWithExtracredit}
          amountShipmentForexProduct={amountShipmentForexProduct}
          amountWallet={amountWallet}
          amountBankTransfer={amountBankTransfer}
          cashback={cashback}
          remainingPrice={remainingPrice}
          loading={loading}
          setLoading={setLoading}
          showErrorToast={showErrorToast}
          page={page}
          setPage={setPage}
          canProceed={canProceed}
          validateCheckout={validatePaymentCheckout}
          isServiceOrDownloadable={isServiceOrDownloadable}
          hasCompleteAddress={hasCompleteAddress}
          bankTransferReceipt={bankTransferReceipt}
          isPickup={isPickup}
          userInfo={userInfo}
        />
      </div>
    </div>
  );
};

const Checkout = (props) => {
  return <CheckoutContent {...props} />;
};

export default Checkout;
